import type { discretoPt } from './discreto-pt';

export const discretoEn: typeof discretoPt = {
  discreto: {
    ocultar: 'Hide values',
    mostrar: 'Show values',
    estadoLigado: 'On',
    dica: '{{acao}} ({{atalho}})',
    valorOculto: 'hidden value',
    campoOculto: '{{rotulo}}: hidden value',
    ligado: 'Privacy mode on. Values hidden.',
    desligado: 'Privacy mode off. Values visible.',
    preferencias: 'Privacy mode preferences',
    noAparelho: 'These preferences are saved on this device only.',
    atalho: 'Keyboard shortcut: {{atalho}} turns privacy mode on and off on any screen.',
    inatividade: 'Turn on by itself after a period without use',
    inatividadeAjuda: 'With no mouse or keyboard activity for this long, values are hidden. Typing or clicking inside the frame of an external link counts as use; with the focus idle inside the frame, this time only starts counting after 15 minutes.',
    inatividadeDesligado: 'Off',
    minutos_one: '{{count}} minute',
    minutos_other: '{{count}} minutes',
    nomes: 'Also hide names of people and companies',
    nomesAjuda: 'Shows the initials only.',
    exportarTitulo: 'Privacy mode is on',
    exportarAviso: 'The file comes out with the real values.',
    imprimirAviso: 'The certificate is printed with the real name.',
    copiarTitulo: 'Privacy mode is on',
    copiarAviso: 'The copied text carries the real values.',
    secao: 'Privacy mode',
    secaoAjuda: 'Hides amounts, documents and contacts on screen, like the eye in banking apps. The eye button in the top bar turns it on and off.',
  },
};
